export default {"breakpoint":{"thresholds":{"xs":320,"sm":600,"md":1024,"lg":1172},"scrollBarWidth":0},"theme":{"disable":true}}
